import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = "zaazpe";

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: "",
    });

    const encodedPassword = encodeURIComponent(password);
    api
      .userPassLogin(
        {
          username,
          password: encodedPassword,
        },
        parameters
      )
      .then((response) => {
        setOnLogin(false);
        window.location =
          parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = translate("RequestLoginErrorMessage");

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false);
        setError({ open: true, message: message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="zaazpe-container" ref={nodeRef}>
        <div className="zaazpe-logoForm-container">
          <Form onSubmit={(event) => onSubmit(event)} className="zaazpe-form">
            <p className="text-form">{translate("Header")}</p>
            <input
              className="zaazpeInput usernameInput input"
              disabled={onLogin}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
              onChange={(e) => setUsername(e.target.value)}
              placeholder={translate("PlaceholderUserName")}
            />
            <input
              className="zaazpeInput passwordInput input"
              required={true}
              disabled={onLogin}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
              placeholder={translate("PlaceholderPassword")}
              onChange={(e) => setPassword(e.target.value)}
            />
            {!onLogin ? (
              <div className="zaazpe-submit-container">
                <button
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  className="zaazpeSubmit"
                  disabled={!props.turnstileSuccess}
                >
                  {translate("ButtonEnter")}
                </button>
                <button
                  tabIndex={1}
                  type="button"
                  //id="submmit"
                  className="zaazpeSubmit"
                  onClick={() => window.location.href = "https://account-dgo.scordsoft.net/"}
                >
                  {translate("ChangePassword")}
                </button>
              </div>

            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
